import type { EventReviewUserEvents } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const getUserEvents = async (
  roomId: string,
  start: string,
  end: string,
) => {
  const url = `/eventReview/v1/userEvents/${roomId}/${start}/${end}`;
  const res = await Api.get<EventReviewUserEvents[]>(url);
  return res && res.data;
};
